module.exports = __webpack_public_path__ + "img/borders5.3131144a.png";